// extracted by css-extract-rspack-plugin
export default {"Box":"VerifyAttestation-module__Box__CEL64","CopyToClipboardButton":"VerifyAttestation-module__CopyToClipboardButton__ql5xo"};